"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const theme = {
    componentStyles: {
        Button: {
            root: {
                fontSize: '80%',
                height: '3.5rem',
            },
        },
    },
};
exports.default = theme;
